
<template>
    <div @click="selectContact()" :class="['chat__contact flex items-center px-2 lg:px-4 pt-2 pb-2', (dialog && dialog.is_open) && 'active']">
        <div class="contact__avatar mr-2" style="height:42px;">
            <vs-avatar class="border-2 border-solid border-white m-0" v-if="contact.avatar" :src="contact.avatar" size="42px" />
            <vs-avatar class="border-2 border-solid border-white m-0" v-else :text="avatarText" size="42px" />
        </div>
        <div class="contact__container w-full flex items-center justify-between overflow-hidden">
            <div class="contact__info flex flex-col truncate w-5/6">
                <h6 v-if="group" class="font-semibold truncate">{{ contact.name }}</h6>
                <h6 v-else class="font-semibold truncate">{{ contact.full_name }}</h6>
                <div class="text-primary text-sm" v-if="isSearch && contact.member_count > 2">{{$t('group_chat')}}</div>
                <span v-if="dialog" class="whitespace-no-wrap text-sm">{{ $moment(dialog.last_sent).fromNow() }}</span>
                <div v-if="chatMember" class="flex mt-1 dialog_chip">
                    <vs-chip v-if="chatMember.is_author" transparent color="primary">
                        {{$t('owner')}}
                    </vs-chip>
                    <vs-chip v-if="!chatMember.is_author && chatMember.is_moderator" transparent color="success">
                        {{$t('moderator')}}
                    </vs-chip>
                </div>
            </div>

            <vs-dropdown class="cursor-pointer" vs-trigger-click v-if="actionCheck">
                <a class="flex items-center" href.prevent>
                    <feather-icon icon="MoreVerticalIcon" svgClasses="h-3 w-3" />
                </a>
                <vs-dropdown-menu>
                    <template v-if="isAuthor">
                        <vs-dropdown-item
                            v-if="chatMember.is_moderator"
                            @click="moderatorDismiss()"
                            class="whitespace-nowrap">
                                {{$t('pick_up_a_moderator')}}
                        </vs-dropdown-item>
                        <vs-dropdown-item
                            v-else
                            @click="moderatorAssign()"
                            class="whitespace-nowrap">
                                {{$t('submit_a_moderator')}}
                        </vs-dropdown-item>
                    </template>
                    <vs-dropdown-item
                        @click="memberDelete()"
                        class="whitespace-nowrap text-danger">
                            {{$t('exclude')}}
                    </vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>

            <div v-if="dialog && !checkBoxMode" class="chat__contact__meta flex self-start flex-col items-end w-1/6">
                <vs-chip class="number" color="primary" v-if="dialog && dialog.new_message_count > 0">{{ dialog.new_message_count }}</vs-chip>
            </div>
            <div v-if="checkBoxMode" class="flex item-center">
                <template v-if="thisSelected && selected.length > 1">
                    <vs-checkbox class="moderate_check mr-2" :vs-value="contact.id" v-model="moderate">
                        {{$t('moderator')}}
                    </vs-checkbox>
                </template>
                <vs-checkbox :vs-value="contact.id" v-model="selected" />
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
    props: {
        contact: {
            type: Object,
            required: true
        },
        dialog: {
            type: Object,
            default: () => null
        },
        checkBoxMode: {
            type: Boolean,
            default: false
        },
        group: {
            type: Boolean,
            default: false
        },
        chatMember: {
            type: Object,
            default: () => null
        },
        clickSelect: {
            type: Boolean,
            default: false
        },
        isSearch: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        async moderatorDismiss() {
            try {
                await this.$store.dispatch('chat/moderatorDismiss', this.contact)
            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'success'
                })
            }
        },
        async moderatorAssign() {
            try {
                await this.$store.dispatch('chat/moderatorAssign', this.contact)
            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'success'
                })
            }
        },
        async memberDelete() {
            try {
                await this.$store.dispatch('chat/memberDelete', this.contact)
            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'success'
                })
            }
        },
        async selectContact() {
            if(this.clickSelect) {
                try {
                    const res = await this.$store.dispatch('chat/chatAddContact', this.contact)
                    if(res) {
                        this.$vs.notify({
                            text: this.$t('member_added'),
                            color: 'success'
                        })
                    }
                } catch(e) {
                    this.$vs.notify({
                        text: this.$t('error'),
                        color: 'success'
                    })
                }
            }
        }
    },
    computed: {
        ...mapState({
            openDialog: state => state.chat.openDialog,
            user: state => state.user.user
        }),
        isAuthor() {
            if(this.openDialog.author.profileId === this.user.profileId && this.user.profileId !== this.contact.id)
                return true
        },
        actionCheck() {
            if(this.chatMember) {
                if(this.isAuthor
                || this.openDialog.is_moderator && !this.chatMember.is_moderator && !this.chatMember.is_author && this.user.profileId !== this.contact.id)
                    return true
                else
                    return false
            }
        },
        selected: {
            get() {
                return this.$store.state.chat.selectedContacts
            },
            set(val) {
                this.$store.commit('chat/SET_SELECTED_CONTACTS', val)
            }
        },
        moderate: {
            get() {
                return this.$store.state.chat.moderate
            },
            set(val) {
                this.$store.commit('chat/SET_MODERATE', val)
            }
        },
        thisSelected() {
            if(this.selected) {
                const find = this.selected.find(item => item === this.contact.id)
                return find
            } else
                return null
        },
        avatarText() {
            let name
            if(this.group)
                name = this.contact.name
            else
                name = this.contact.full_name

            if(name) {
                // Возвращяем инициалы пользователя
                let title,
                    text = name
                const textAr = text.split(' ')
                if (textAr.length) {
                    const newTitle = []
                    textAr.forEach(item => {
                        newTitle.push(item.substr(0, 1).toUpperCase())
                    })
                    title = newTitle.join('')
                } else title = text.substr(0, 1)
                return title
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.chat__contact{
    &.active{
        background: rgba(var(--vs-primary),.15);
        h6{
            color: rgba(var(--vs-primary),1);
        }
    }
}
</style>

<style lang="scss">
.dialog_chip{
    .con-vs-chip{
        font-size: 9px;
        min-height: 17px;
        padding-right: 6px;
        .text-chip{
            margin-left: 6px;
        }
    }
}
.moderate_check{
    .vs-checkbox{
        display: none;
    }
    .con-slot-label{
        background: #dadada;
        padding: 2px 6px;
        font-size: 12px;
        border-radius: 15px;
    }
    input:checked~.con-slot-label{
        background: rgba(var(--vs-primary),.15);
        color: rgba(var(--vs-primary),1);
    }
}
</style>
